import React from 'react'
import { DropDownBtnHLPure, InputSwitchHLPure } from '../../../pures'
import { useTranslation } from 'react-i18next'

const AdditionalFilters = ({
    userOptions,
    iconFilter,
    selectedUser,
    filterIsValid,
    categoryOptions,
    setSelectedUser,
    selectedCategory,
    setFilterIsValid,
    hasActiveFilters,
    createdDateOptions,
    handleClearFilters,
    selectedCreatedDate,
    filterSigningInGovo,
    setSelectedCategory,
    typeDocumentOptions,
    selectedTypeDocument,
    setSelectedTypeDocument,
    setFilterSigningInGovo,
    setSelectedCreatedDate
}) => {
    const { t } = useTranslation()

    return (
        <div className='digitalVaultSearchView-additional-filters'>
            <div className='digitalVaultSearchView-filter-group'>
                <DropDownBtnHLPure
                    optionsDropDown={categoryOptions}
                    optionsValue={selectedCategory}
                    valueItem={'id'}
                    nameOption={'name'}
                    onDropDownChange={(e) => setSelectedCategory(e.target.value)}
                    iconFilter={false}
                />
            </div>

            <div className='digitalVaultSearchView-filter-group'>
                <DropDownBtnHLPure
                    optionsDropDown={typeDocumentOptions}
                    optionsValue={selectedTypeDocument}
                    valueItem={'id'}
                    nameOption={'name'}
                    onDropDownChange={(e) => setSelectedTypeDocument(e.target.value)}
                    iconFilter={false}
                />
            </div>

            <div className='digitalVaultSearchView-filter-group'>
                <DropDownBtnHLPure
                    optionsDropDown={createdDateOptions}
                    optionsValue={selectedCreatedDate}
                    valueItem={'id'}
                    nameOption={'name'}
                    onDropDownChange={(e) => setSelectedCreatedDate(e.target.value)}
                    iconFilter={false}
                />
            </div>

            <div className='digitalVaultSearchView-filter-group'>
                <DropDownBtnHLPure
                    optionsDropDown={userOptions}
                    optionsValue={selectedUser}
                    valueItem={'id'}
                    nameOption={'name'}
                    onDropDownChange={(e) => setSelectedUser(e.target.value)}
                    iconFilter={false}
                />
            </div>

            <div className='digitalVaultSearchView-filter-group digitalVaultSearchView-switch-filter'>
                <InputSwitchHLPure
                    labelInput={t('digital.vault.search.document.validity')}
                    checked={filterIsValid}
                    onChange={(e) => setFilterIsValid(e.value)}
                />
            </div>

            <div className='digitalVaultSearchView-filter-group digitalVaultSearchView-switch-filter'>
                <InputSwitchHLPure
                    labelInput={t('digital.vault.search.document.signed.with.govo')}
                    checked={filterSigningInGovo}
                    onChange={(e) => setFilterSigningInGovo(e.value)}
                />
            </div>

            {hasActiveFilters() && (
                <div className='digitalVaultSearchView-filter-group digitalVaultSearchView-clear-filters'>
                    <button
                        onClick={handleClearFilters}
                        className='digitalVaultSearchView-clear-filters-btn'
                        title='Limpiar filtros'
                    >
                        <img
                            src={iconFilter}
                            height={25}
                            width={25}
                            alt='Limpiar filtros'
                        />
                    </button>
                </div>
            )}
        </div>
    )
}

export default AdditionalFilters
